import type { PageLoad } from './$types';
import * as m from '$lib/paraglide/messages';
import { SITE_URL } from '$lib/constants/links';
import { serializeSchema } from '$lib/jsonld';
import { buildSeoMeta } from '$lib/seo';

export const prerender = true;

export const load: PageLoad = ({ url }) => {
	const pageUrl = `${SITE_URL}/contact`;

	return {
		seo: buildSeoMeta({
			type: 'home',
			title: m.contact_me(),
			url: url.href,
			description: m.contact_page_description()
		}),
		jsonld: serializeSchema({
			'@context': 'https://schema.org',
			'@graph': [
				{
					'@type': 'ContactPage',
					'@id': `${pageUrl}#webpage`,
					url: url.href,
					name: m.contact_me(),
					description: m.contact_page_description(),
					breadcrumb: { '@id': `${pageUrl}#breadcrumb` },
					isPartOf: { '@id': `${SITE_URL}/#website` }
				},
				{
					'@type': 'Person',
					'@id': `${SITE_URL}/#person`,
					name: 'Juslin Komenan',
					jobTitle: 'Product Engineer & Digital Architect',
					url: SITE_URL,
					address: {
						'@type': 'PostalAddress',
						addressLocality: 'Abidjan',
						addressCountry: 'CI'
					},
					email: 'komenan.komenan0@gmail.com',
					telephone: '+225 07 59 84 28 78'
				},
				{
					'@type': 'FAQPage',
					'@id': `${pageUrl}#faq`,
					mainEntity: [
						{
							'@type': 'Question',
							name: 'Quels types de projets acceptez-vous ?',
							acceptedAnswer: {
								'@type': 'Answer',
								text: "J'interviens sur la création d'applications web (SvelteKit), le développement backend (Deno) et l'architecture logicielle (Clean Architecture)."
							}
						},
						{
							'@type': 'Question',
							name: 'Comment se déroule le premier échange ?',
							acceptedAnswer: {
								'@type': 'Answer',
								text: "Après réception de votre message, nous convenons d'un appel court pour définir vos besoins, suivi d'une proposition détaillée sous 3 jours."
							}
						}
					]
				}
			]
		})
	};
};
